(function () {
  'use strict';

  // Auto-expands every filter group (Availability, Price, Color, Size, etc.)
  // inside the "Filter and sort" panel so all headings and their options are
  // visible at once, without needing to click into each one separately.
  // This also permanently locks each group open (see lockGroupsOpen) so a
  // shopper can no longer collapse a group by tapping its heading; this
  // function keeps re-opening anything Dawn re-renders as closed (e.g.
  // after applying a filter, which Dawn re-renders via fetch).

  function expandAllFacets() {
    document.querySelectorAll('facet-filters-form details, .facets details').forEach(function (details) {
      if (!details.hasAttribute('open')) {
        details.setAttribute('open', '');
      }
    });
  }

  // Reads the visible heading text of a filter group's <summary> (e.g.
  // "Color", "Size") so we can target just those two groups for the
  // compact-layout treatment below, without touching Availability/Price.
  function getGroupName(details) {
    var span = details.querySelector('summary > div > span');
    return span ? span.textContent.trim().toLowerCase() : '';
  }

  // Color: tags the group's option list so CSS can lay the swatches out as
  // a wrapping row of dots, and hides the text label/count next to each
  // swatch (selection is shown by the tick badge CSS adds on the swatch
  // itself instead).
  // Size: tags the group's option list so CSS can lay it out as a wrapping
  // grid (2-3 rows), and shortens each label down to just its abbreviation,
  // e.g. "Extra small (XS) (52)" -> "XS".
  function compactColorAndSizeGroups() {
    document.querySelectorAll('.mobile-facets__details').forEach(function (details) {
      var name = getGroupName(details);
      var list = details.querySelector('.mobile-facets__list');
      if (!list) return;

      if (name === 'color') {
        list.classList.add('mobile-facets__list--dots');
      }

      if (name === 'size') {
        list.classList.add('mobile-facets__list--grid');
        list.querySelectorAll('.facet-checkbox__text-label').forEach(function (labelSpan) {
          var match = labelSpan.textContent.match(/\(([^()]+)\)\s*$/);
          if (match && labelSpan.textContent.trim() !== match[1]) {
            labelSpan.textContent = match[1];
          }
          // Blank the trailing " (count)" text node that follows the label span
          // inside the same .facet-checkbox__text wrapper.
          var parent = labelSpan.parentElement;
          if (parent) {
            Array.prototype.forEach.call(parent.childNodes, function (node) {
              if (node !== labelSpan && node.nodeType === Node.TEXT_NODE) {
                node.textContent = '';
              }
            });
          }
        });
      }
    });
  }

  function runAll() {
    expandAllFacets();
    compactColorAndSizeGroups();
  }

  // Filter groups (Availability, Price, Color, Size) should always stay
  // expanded -- block the native <details> toggle when a shopper taps a
  // group heading, so a group can never be collapsed again. This is a
  // single delegated listener attached once, so it keeps working even
  // after Dawn replaces the filter markup via its AJAX re-render.
  //
  // Also guards against a real bug: on touch devices, tapping a plain <a>
  // link (like "Remove all") does not always move keyboard focus onto it
  // the way tapping a checkbox does. Dawn's menu-drawer component treats
  // focus leaving the drawer as "the shopper is done, close it" (see
  // MenuDrawer.onFocusOut in global.js) -- so on a phone, tapping Remove
  // all can make the whole Filter panel snap shut, and because that close
  // happens through Dawn's own animation path rather than a fresh open,
  // reopening it can land back on collapsed groups. Explicitly focusing
  // the Remove all control keeps focus inside the drawer so that never
  // fires.
  function lockGroupsOpen() {
    document.addEventListener(
      'click',
      function (event) {
        var summary = event.target.closest('.mobile-facets .mobile-facets__summary');
        if (summary) {
          event.preventDefault();
        }

        var clearControl = event.target.closest('.mobile-facets .mobile-facets__clear');
        if (clearControl) {
          clearControl.focus();
        }
      },
      true
    );
  }

  function init() {
    runAll();
    lockGroupsOpen();

    var target = document.getElementById('MainContent') || document.body;
    var observer = new MutationObserver(function () {
      runAll();
    });
    // childList/subtree catches Dawn's AJAX re-render after a filter is
    // applied. attributes/attributeFilter:['open'] is just as important:
    // Dawn's MenuDrawer.closeMenuDrawer() strips the `open` attribute from
    // every filter group's <details> whenever the panel closes (by the X
    // button, Apply, or the focus-loss case handled above) -- without
    // watching for that, groups would come back collapsed the next time
    // the panel opens, since stripping an attribute isn't a childList
    // change.
    observer.observe(target, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['open'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
